import React from 'react';
import { Steps, Breadcrumb, Layout, notification, Modal } from 'antd/lib';
import * as Icons from '@ant-design/icons';
import { graphql, compose, withApollo } from 'react-apollo';
import Loading from '../../common/Loading';

import FormPersona from '../../tramites/formularios/FormPersona';
import FormInformacionSumaria from '../../tramites/formularios/FormInformacionSumaria';
import getInformacionSumariaPorId from '../../../graphql/querys/tramites/getInformacionSumariaPorId.graphql';
import insertPersona from '../../../graphql/mutations/persona/insertPersona.graphql';
import updateInformacionSumariaPorId from '../../../graphql/mutations/tramites/updateInformacionSumariaPorId.graphql';
import getInformacionesSumarias from '../../../graphql/querys/tramites/getInformacionesSumarias.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';

const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

@compose(
  graphql(insertPersona, {
    name: 'createPers',
  }),
  graphql(updateInformacionSumariaPorId, {
    name: 'updateInformacionSumariaPorId',
    options: {
      refetchQueries: [{ query: getInformacionesSumarias }],
    },
  }),
  graphql(getUsuario)
)
class EditarInformacionSumaria extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      declarante: {},
      testigo1: {},
      testigo2: {},
      ente_receptor: '',
      testimonio: '',
      fecha_creacion: '',
      step: 0,
      guardado: false,
      loading: true,
    };

    this.props.client
      .query({
        query: getInformacionSumariaPorId,
        variables: { _id: this.props.match.params.id },
      })
      .then(res => {
        const informacion = res.data.getInformacionSumariaPorId;

        this.setState({
          loading: false,
          declarante: informacion.declarante,
          testigo1: informacion.testigo1,
          testigo2: informacion.testigo2,
          ente_receptor: informacion.ente_receptor,
          testimonio: informacion.testimonio,
          fecha_creacion: informacion.fecha_creacion,
          _id: informacion._id,
        });
      })
      .catch(err => {
        console.log('Error en la creacion');
        console.log(err);

        Modal.error({
          title: 'Error en la inicializacion del componente grafico',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });

    this.guardarDeclarante = this.guardarDeclarante.bind(this);
    this.guardarTestigo1 = this.guardarTestigo1.bind(this);
    this.guardarTestigo2 = this.guardarTestigo1.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.guardarDatosInformacionSumaria = this.guardarDatosInformacionSumaria.bind(
      this
    );
  }

  guardarDeclarante(persona) {
    this.props
      .createPers({
        variables: { persona: persona },
      })
      .then(respuestaPersona => {
        let declarante = respuestaPersona.data.insertPersona;
        if (respuestaPersona) {
          this.setState(
            {
              declarante: {
                ...this.state.declarante,
                ...declarante,
              },
            },
            function() {
              this.siguientePaso();
            }
          );
        }
      });
  }
  guardarTestigo1(persona) {
    // console.log(persona);

    this.props
      .createPers({
        variables: { persona: persona },
      })
      .then(respuestaPersona => {
        let testigo1 = respuestaPersona.data.insertPersona;
        if (testigo1) {
          this.setState(
            {
              testigo1: {
                ...this.state.testigo1,
                ...testigo1,
              },
            },
            function() {
              this.siguientePaso();
            }
          );
        }
      });
  }
  guardarTestigo2(persona) {
    this.props
      .createPers({
        variables: { persona: persona },
      })
      .then(respuestaPersona => {
        let testigo2 = respuestaPersona.data.insertPersona;
        if (testigo2) {
          this.setState(
            {
              testigo2: {
                ...this.state.testigo2,
                ...persona,
              },
            },
            function() {
              this.siguientePaso();
            }
          );
        }
      });
  }

  guardarDatosInformacionSumaria(datos) {
    //Actualizamos la persona si es que existe, o la insertamos si creo una nueva.
    //Todo esto gracias al upsert en mongoDB.

    //Armamos una copia del objeto persona, y le sacmaos la propiedad __typename para que sea del tipo "InputPersona" de graphql

    let nuevaInformacion_Sumaria = {
      testimonio: datos.testimonio,
      fecha_creacion: this.state.fecha_creacion,
      idDeclarante: this.state.declarante._id,
      idTestigo1: this.state.testigo1._id,
      idTestigo2: this.state.testigo2._id,
      ente_receptor: datos.ente_receptor,
      idOrganismo: this.props.data.getUsuario.organismo._id,
    };

    this.props
      .updateInformacionSumariaPorId({
        variables: {
          _id: this.state._id,
          nuevaInformacion_sumaria: nuevaInformacion_Sumaria,
        },
      })
      // eslint-disable-next-line no-unused-vars
      .then(resInformacion => {
        notification.success({
          message: 'Actualizacion Correcta',
          description:
            'Se ha registrado los nuevos datos de la informacion sumaria',
        });

        this.props.history.push('/');
      })
      .catch(err => {
        console.log('Error en la actualizacion de la informacion sumaria');
        console.log(err);

        Modal.error({
          title: 'Error en la actualizacion de la informacion sumaria',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  }

  onCancel() {
    this.setState({
      fase: 0,
    });
  }

  siguientePaso() {
    let paso = this.state.step;
    paso++;
    this.setState({
      ...this.state,
      step: paso,
    });
  }

  anteriorPaso() {
    let paso = this.state.step;
    if (paso > 0) {
      paso--;
      this.setState({
        ...this.state,
        step: paso,
      });
    }
  }

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    const { Step } = Steps;
    let { step } = this.state;
    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Informacion Sumaria</Breadcrumb.Item>
          <Breadcrumb.Item>Editar</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.FileTextOutlined /> Editar Informacion Sumaria
          </h2>
          <br />
          <Steps className="stepsFormularios" current={step}>
            <Step title="Datos Declarante" />
            <Step title="Datos Testigo 1" />
            <Step title="Datos Testigo 2" />
            <Step title="Datos de la Informacion Sumaria" />
          </Steps>
          <div style={estiloContent}>
            {step === 0 && (
              <FormPersona
                className="formularios"
                onSubmit={this.guardarDeclarante}
                onAnterior={() => this.props.history.goBack()}
                persona={this.state.declarante}
              />
            )}
            {step === 1 && (
              <FormPersona
                className="formularios"
                onSubmit={this.guardarTestigo1}
                onAnterior={() => this.props.history.goBack()}
                persona={this.state.testigo1}
              />
            )}
            {step === 2 && (
              <FormPersona
                className="formularios"
                onSubmit={this.guardarTestigo2}
                onAnterior={() => this.props.history.goBack()}
                persona={this.state.testigo2}
              />
            )}
            {step === 3 && (
              <FormInformacionSumaria
                onSubmit={this.guardarDatosInformacionSumaria}
                datos={{
                  ente_receptor: this.state.ente_receptor,
                  testimonio: this.state.testimonio,
                }}
                config={{ creacion: false }}
              />
            )}
          </div>
        </Layout>
      </div>
    );
  }
}

export default withApollo(EditarInformacionSumaria);
